import React from 'react';
import PropTypes from 'prop-types';
import { Grow, Paper } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	content: {
		overflow: 'auto',
		padding: '1rem',
		//margin: "2rem",
		width: '100%',
		maxWidth: '1920px',
		margin: 'auto',
		marginTop: '0px',
		backgroundColor: theme.palette.common.iceBlue,
	},
	paper: {
		padding: '2rem',
		backgroundColor: theme.palette.common.white,
	},
}));

const Content = ({ children }) => {
	const classes = useStyles();
	return (
		<Grow
			in={true}
			style={{ transformOrigin: '50% 0 0' }}
			{...(true ? { timeout: 500 } : {})}
		>
			<main className={classes.content}>
				<Paper className={classes.paper}>{children}</Paper>
			</main>
		</Grow>
	);
};

Content.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.element),
		PropTypes.element.isRequired,
	]),
};

export default Content;
